import { Languages } from "src/common/descriptions/types";
import { CashboxStatementsDescriptions } from "./types";

const DescriptionsEnUs: CashboxStatementsDescriptions = {
    TITLE: "Cashbox Statement Records",
    TABLE: {
        ACTION_BUTTON: "Get Records",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Datetime",
        DESCRIPTION: "Description",
        PREVIOUS: "Previous",
        CREDIT: "Credit",
        DEBIT: "Debit",
        BALANCE: "Balance",
        ACTIONS: "Actions",
    },
    BALANCE: "Balance:",
}

const DescriptionsEsUs: CashboxStatementsDescriptions = {
    TITLE: "Arqueo de Caja",
    TABLE: {
        ACTION_BUTTON: "Ver Registros",
        SEARCH_PLACEHOLDER: "Buscar",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Fecha",
        DESCRIPTION: "Descripción",
        PREVIOUS: "Anterior",
        CREDIT: "Crédito",
        DEBIT: "Débito",
        BALANCE: "Saldo",
        ACTIONS: "Acciones",
    },
    BALANCE: "Saldo:",
}

export const cashboxStatementsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
